<div class="contractor-report-container">
  <h1 class="page-title">承攬商與承攬人員基本資訊維護</h1>

  <!-- 表單資料顯示區塊 -->
  <div class="panel showlist-panel mt-4">
    <div class="panel-content">
      <app-showlist
        [formName]="'承攬商資料'"
        [formId]="contractorFormId"
        (dataUpdated)="onShowlistDataUpdated()">
      </app-showlist>
    </div>
  </div>
</div>
